import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'

const TYPES = {
  douleur: { color: '#E24B4A', label: 'Douleur', bg: '#FCEBEE', border: '#F09595', text: '#A32D2D' },
  traitement: { color: '#1D9E75', label: 'Traitement', bg: '#E1F5EE', border: '#5DCAA5', text: '#0F6E56' },
}

const ZONES_FACE = `
  <g class="zone" data-zone="Crâne">
    <ellipse cx="140" cy="36" rx="30" ry="34" class="os"/>
    <ellipse cx="140" cy="52" rx="26" ry="14" class="os-dark"/>
    <rect x="122" y="62" width="36" height="7" rx="2" class="os"/>
  </g>
  <g class="zone" data-zone="Mandibule">
    <path d="M120 69 Q112 84 122 93 Q140 99 158 93 Q168 84 160 69" fill="#E8DDD0" stroke="#B8A898" stroke-width="0.8"/>
  </g>
  <g class="zone" data-zone="Cervicales (C1-C7)">
    <rect x="131" y="98" width="18" height="8" rx="2" class="os"/>
    <rect x="130" y="107" width="20" height="8" rx="2" class="os"/>
    <rect x="129" y="116" width="22" height="8" rx="2" class="os"/>
    <rect x="128" y="125" width="24" height="8" rx="2" class="os"/>
    <rect x="127" y="134" width="26" height="7" rx="2" class="os"/>
    <rect x="126" y="142" width="28" height="7" rx="2" class="os"/>
    <rect x="125" y="150" width="30" height="7" rx="2" class="os"/>
  </g>
  <g class="zone" data-zone="Clavicules">
    <path d="M125 160 Q102 154 84 159" fill="none" stroke="#B8A898" stroke-width="4" stroke-linecap="round"/>
    <path d="M155 160 Q178 154 196 159" fill="none" stroke="#B8A898" stroke-width="4" stroke-linecap="round"/>
  </g>
  <g class="zone" data-zone="Sternum">
    <rect x="132" y="160" width="16" height="58" rx="3" class="os"/>
    <rect x="129" y="160" width="22" height="9" rx="3" class="os-dark"/>
  </g>
  <g class="zone" data-zone="Cage thoracique">
    <path d="M133 168 Q109 171 90 183 Q86 193 92 200 Q112 208 133 206" fill="none" stroke="#C8B8A8" stroke-width="2.5" stroke-linecap="round"/>
    <path d="M133 176 Q107 180 88 194 Q84 206 90 213 Q110 221 133 219" fill="none" stroke="#C8B8A8" stroke-width="2.5" stroke-linecap="round"/>
    <path d="M133 184 Q109 188 90 203 Q86 216 92 223 Q112 231 133 229" fill="none" stroke="#C8B8A8" stroke-width="2.5" stroke-linecap="round"/>
    <path d="M147 168 Q171 171 190 183 Q194 193 188 200 Q168 208 147 206" fill="none" stroke="#C8B8A8" stroke-width="2.5" stroke-linecap="round"/>
    <path d="M147 176 Q173 180 192 194 Q196 206 190 213 Q170 221 147 219" fill="none" stroke="#C8B8A8" stroke-width="2.5" stroke-linecap="round"/>
    <path d="M147 184 Q171 188 190 203 Q194 216 188 223 Q168 231 147 229" fill="none" stroke="#C8B8A8" stroke-width="2.5" stroke-linecap="round"/>
  </g>
  <g class="zone" data-zone="Épaule gauche"><ellipse cx="76" cy="182" rx="13" ry="16" class="os" transform="rotate(-12 76 182)"/></g>
  <g class="zone" data-zone="Épaule droite"><ellipse cx="204" cy="182" rx="13" ry="16" class="os" transform="rotate(12 204 182)"/></g>
  <g class="zone" data-zone="Dorsales (D1-D12)">
    <rect x="130" y="160" width="20" height="7" rx="1" class="os-dark"/>
    <rect x="130" y="168" width="20" height="7" rx="1" class="os-dark"/>
    <rect x="130" y="176" width="20" height="7" rx="1" class="os-dark"/>
    <rect x="130" y="184" width="20" height="7" rx="1" class="os-dark"/>
    <rect x="130" y="192" width="20" height="7" rx="1" class="os-dark"/>
    <rect x="129" y="200" width="22" height="7" rx="1" class="os-dark"/>
    <rect x="129" y="208" width="22" height="7" rx="1" class="os-dark"/>
    <rect x="129" y="216" width="22" height="7" rx="1" class="os-dark"/>
    <rect x="128" y="224" width="24" height="7" rx="1" class="os-dark"/>
    <rect x="128" y="232" width="24" height="7" rx="1" class="os-dark"/>
    <rect x="127" y="240" width="26" height="7" rx="1" class="os-dark"/>
    <rect x="127" y="248" width="26" height="7" rx="1" class="os-dark"/>
  </g>
  <g class="zone" data-zone="Lombaires (L1-L5)">
    <rect x="126" y="256" width="28" height="8" rx="2" class="os"/>
    <rect x="126" y="265" width="28" height="8" rx="2" class="os"/>
    <rect x="126" y="274" width="28" height="8" rx="2" class="os"/>
    <rect x="125" y="283" width="30" height="8" rx="2" class="os"/>
    <rect x="125" y="292" width="30" height="8" rx="2" class="os"/>
  </g>
  <g class="zone" data-zone="Sacrum"><path d="M126 301 Q120 305 118 318 Q118 330 126 336 Q133 340 140 340 Q147 340 154 336 Q162 330 162 318 Q160 305 154 301 Z" class="os-dark"/></g>
  <g class="zone" data-zone="Ilium gauche"><path d="M118 304 Q104 300 94 308 Q86 318 88 330 Q92 340 104 344 Q116 346 122 338 Q126 330 122 316 Z" class="os"/></g>
  <g class="zone" data-zone="Ilium droit"><path d="M162 304 Q176 300 186 308 Q194 318 192 330 Q188 340 176 344 Q164 346 158 338 Q154 330 158 316 Z" class="os"/></g>
  <g class="zone" data-zone="Pubis / Symphyse"><path d="M122 338 Q130 344 140 344 Q150 344 158 338 Q155 348 140 350 Q125 348 122 338 Z" class="os-dark"/></g>
  <g class="zone" data-zone="Bras gauche (humérus)"><rect x="60" y="196" width="11" height="58" rx="4" class="os" transform="rotate(8 65 225)"/></g>
  <g class="zone" data-zone="Bras droit (humérus)"><rect x="209" y="196" width="11" height="58" rx="4" class="os" transform="rotate(-8 214 225)"/></g>
  <g class="zone" data-zone="Coude gauche"><ellipse cx="62" cy="256" rx="9" ry="8" class="os-dark"/></g>
  <g class="zone" data-zone="Coude droit"><ellipse cx="218" cy="256" rx="9" ry="8" class="os-dark"/></g>
  <g class="zone" data-zone="Avant-bras gauche">
    <rect x="48" y="263" width="7" height="52" rx="3" class="os" transform="rotate(4 51 289)"/>
    <rect x="57" y="264" width="7" height="50" rx="3" class="os" transform="rotate(4 60 289)"/>
  </g>
  <g class="zone" data-zone="Avant-bras droit">
    <rect x="215" y="263" width="7" height="52" rx="3" class="os" transform="rotate(-4 218 289)"/>
    <rect x="224" y="264" width="7" height="50" rx="3" class="os" transform="rotate(-4 227 289)"/>
  </g>
  <g class="zone" data-zone="Poignet / Main gauche"><ellipse cx="52" cy="318" rx="11" ry="14" class="os"/></g>
  <g class="zone" data-zone="Poignet / Main droite"><ellipse cx="228" cy="318" rx="11" ry="14" class="os"/></g>
  <g class="zone" data-zone="Cuisse gauche (fémur)"><rect x="108" y="348" width="16" height="76" rx="5" class="os" transform="rotate(4 116 386)"/></g>
  <g class="zone" data-zone="Cuisse droite (fémur)"><rect x="156" y="348" width="16" height="76" rx="5" class="os" transform="rotate(-4 164 386)"/></g>
  <g class="zone" data-zone="Genou gauche"><ellipse cx="115" cy="428" rx="12" ry="10" class="os-dark"/></g>
  <g class="zone" data-zone="Genou droit"><ellipse cx="165" cy="428" rx="12" ry="10" class="os-dark"/></g>
  <g class="zone" data-zone="Jambe gauche (tibia/péroné)">
    <rect x="109" y="437" width="9" height="66" rx="3" class="os"/>
    <rect x="120" y="439" width="6" height="62" rx="3" class="os-dark"/>
  </g>
  <g class="zone" data-zone="Jambe droite (tibia/péroné)">
    <rect x="162" y="437" width="9" height="66" rx="3" class="os"/>
    <rect x="154" y="439" width="6" height="62" rx="3" class="os-dark"/>
  </g>
  <g class="zone" data-zone="Cheville / Pied gauche">
    <ellipse cx="113" cy="508" rx="8" ry="6" class="os-dark"/>
    <ellipse cx="102" cy="516" rx="17" ry="7" class="os"/>
  </g>
  <g class="zone" data-zone="Cheville / Pied droit">
    <ellipse cx="167" cy="508" rx="8" ry="6" class="os-dark"/>
    <ellipse cx="178" cy="516" rx="17" ry="7" class="os"/>
  </g>
`

const ZONES_DOS = `
  <g class="zone" data-zone="Crâne (occiput)"><ellipse cx="140" cy="36" rx="30" ry="34" class="os"/></g>
  <g class="zone" data-zone="Cervicales (C1-C7)">
    <rect x="131" y="72" width="18" height="8" rx="2" class="os-dark"/>
    <rect x="130" y="81" width="20" height="8" rx="2" class="os-dark"/>
    <rect x="129" y="90" width="22" height="8" rx="2" class="os-dark"/>
    <rect x="128" y="99" width="24" height="8" rx="2" class="os-dark"/>
    <rect x="127" y="108" width="26" height="7" rx="2" class="os-dark"/>
    <rect x="126" y="116" width="28" height="7" rx="2" class="os-dark"/>
    <rect x="125" y="124" width="30" height="7" rx="2" class="os-dark"/>
  </g>
  <g class="zone" data-zone="Omoplate gauche">
    <path d="M82 132 Q70 137 67 158 Q70 178 84 181 Q98 183 106 168 Q110 153 102 138 Z" class="os"/>
    <line x1="82" y1="132" x2="98" y2="181" stroke="#B8A898" stroke-width="0.8"/>
  </g>
  <g class="zone" data-zone="Omoplate droite">
    <path d="M198 132 Q210 137 213 158 Q210 178 196 181 Q182 183 174 168 Q170 153 178 138 Z" class="os"/>
    <line x1="198" y1="132" x2="182" y2="181" stroke="#B8A898" stroke-width="0.8"/>
  </g>
  <g class="zone" data-zone="Dorsales (D1-D12)">
    <rect x="130" y="132" width="20" height="7" rx="1" class="os-dark"/>
    <rect x="130" y="140" width="20" height="7" rx="1" class="os-dark"/>
    <rect x="130" y="148" width="20" height="7" rx="1" class="os-dark"/>
    <rect x="130" y="156" width="20" height="7" rx="1" class="os-dark"/>
    <rect x="129" y="164" width="22" height="7" rx="1" class="os-dark"/>
    <rect x="129" y="172" width="22" height="7" rx="1" class="os-dark"/>
    <rect x="129" y="180" width="22" height="7" rx="1" class="os-dark"/>
    <rect x="128" y="188" width="24" height="7" rx="1" class="os-dark"/>
    <rect x="128" y="196" width="24" height="7" rx="1" class="os-dark"/>
    <rect x="127" y="204" width="26" height="7" rx="1" class="os-dark"/>
    <rect x="127" y="212" width="26" height="7" rx="1" class="os-dark"/>
    <rect x="127" y="220" width="26" height="7" rx="1" class="os-dark"/>
  </g>
  <g class="zone" data-zone="Lombaires (L1-L5)">
    <rect x="126" y="228" width="28" height="8" rx="2" class="os"/>
    <rect x="126" y="237" width="28" height="8" rx="2" class="os"/>
    <rect x="126" y="246" width="28" height="8" rx="2" class="os"/>
    <rect x="125" y="255" width="30" height="8" rx="2" class="os"/>
    <rect x="125" y="264" width="30" height="8" rx="2" class="os"/>
  </g>
  <g class="zone" data-zone="Sacrum / Coccyx">
    <path d="M126 274 Q120 278 118 292 Q118 308 126 314 Q133 318 140 318 Q147 318 154 314 Q162 308 162 292 Q160 278 154 274 Z" class="os-dark"/>
    <rect x="134" y="316" width="12" height="14" rx="3" class="os"/>
  </g>
  <g class="zone" data-zone="Ilium gauche"><path d="M118 278 Q104 274 92 282 Q84 292 86 306 Q90 316 102 320 Q114 322 120 314 Q124 305 120 290 Z" class="os"/></g>
  <g class="zone" data-zone="Ilium droit"><path d="M162 278 Q176 274 188 282 Q196 292 194 306 Q190 316 178 320 Q166 322 160 314 Q156 305 160 290 Z" class="os"/></g>
  <g class="zone" data-zone="Bras gauche (humérus)"><rect x="60" y="170" width="11" height="58" rx="4" class="os" transform="rotate(8 65 199)"/></g>
  <g class="zone" data-zone="Bras droit (humérus)"><rect x="209" y="170" width="11" height="58" rx="4" class="os" transform="rotate(-8 214 199)"/></g>
  <g class="zone" data-zone="Coude gauche"><ellipse cx="62" cy="230" rx="9" ry="8" class="os-dark"/></g>
  <g class="zone" data-zone="Coude droit"><ellipse cx="218" cy="230" rx="9" ry="8" class="os-dark"/></g>
  <g class="zone" data-zone="Avant-bras gauche">
    <rect x="48" y="237" width="7" height="52" rx="3" class="os" transform="rotate(4 51 263)"/>
    <rect x="57" y="238" width="7" height="50" rx="3" class="os" transform="rotate(4 60 263)"/>
  </g>
  <g class="zone" data-zone="Avant-bras droit">
    <rect x="215" y="237" width="7" height="52" rx="3" class="os" transform="rotate(-4 218 263)"/>
    <rect x="224" y="238" width="7" height="50" rx="3" class="os" transform="rotate(-4 227 263)"/>
  </g>
  <g class="zone" data-zone="Poignet / Main gauche"><ellipse cx="52" cy="292" rx="11" ry="14" class="os"/></g>
  <g class="zone" data-zone="Poignet / Main droite"><ellipse cx="228" cy="292" rx="11" ry="14" class="os"/></g>
  <g class="zone" data-zone="Cuisse gauche (fémur)"><rect x="108" y="326" width="16" height="76" rx="5" class="os" transform="rotate(4 116 364)"/></g>
  <g class="zone" data-zone="Cuisse droite (fémur)"><rect x="156" y="326" width="16" height="76" rx="5" class="os" transform="rotate(-4 164 364)"/></g>
  <g class="zone" data-zone="Genou gauche"><ellipse cx="115" cy="406" rx="12" ry="10" class="os-dark"/></g>
  <g class="zone" data-zone="Genou droit"><ellipse cx="165" cy="406" rx="12" ry="10" class="os-dark"/></g>
  <g class="zone" data-zone="Jambe gauche (tibia/péroné)">
    <rect x="109" y="415" width="9" height="66" rx="3" class="os"/>
    <rect x="120" y="417" width="6" height="62" rx="3" class="os-dark"/>
  </g>
  <g class="zone" data-zone="Jambe droite (tibia/péroné)">
    <rect x="162" y="415" width="9" height="66" rx="3" class="os"/>
    <rect x="154" y="417" width="6" height="62" rx="3" class="os-dark"/>
  </g>
  <g class="zone" data-zone="Cheville / Pied gauche">
    <ellipse cx="113" cy="486" rx="8" ry="6" class="os-dark"/>
    <ellipse cx="102" cy="494" rx="17" ry="7" class="os"/>
  </g>
  <g class="zone" data-zone="Cheville / Pied droit">
    <ellipse cx="167" cy="486" rx="8" ry="6" class="os-dark"/>
    <ellipse cx="178" cy="494" rx="17" ry="7" class="os"/>
  </g>
`

const SVG_STYLE = `
  .os { fill: #E8DDD0; stroke: #B8A898; stroke-width: 0.8; }
  .os-dark { fill: #D4C8B8; stroke: #A89888; stroke-width: 0.8; }
  .zone { cursor: crosshair; }
  .zone:hover { opacity: 0.82; }
`

export default function SchemaCorporel({ patientId, consultationId, readOnly = false }) {
  const { praticien } = useAuth()
  const [points, setPoints] = useState([])
  const [typeActif, setTypeActif] = useState('douleur')
  const [vue, setVue] = useState('face')
  const [zoneHover, setZoneHover] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (!patientId) return
    let query = supabase.from('schema_corporel_points').select('*').eq('patient_id', patientId)
    if (consultationId) query = query.eq('consultation_id', consultationId)
    query.order('created_at').then(({ data }) => setPoints(data || []))
  }, [patientId, consultationId])

  function findZone(svg, clientX, clientY) {
    const rect = svg.getBoundingClientRect()
    const vb = svg.viewBox.baseVal
    const sx = (clientX - rect.left) * vb.width / rect.width
    const sy = (clientY - rect.top) * vb.height / rect.height
    const zones = svg.querySelectorAll('.zone')
    for (let z of [...zones].reverse()) {
      if (z.closest('g[style*="none"]')) continue
      const bb = z.getBBox()
      if (sx >= bb.x && sx <= bb.x + bb.width && sy >= bb.y && sy <= bb.y + bb.height)
        return { zone: z.getAttribute('data-zone'), x: sx, y: sy }
    }
    return null
  }

  async function addPoint(e) {
    if (readOnly) return
    const svg = e.currentTarget
    const hit = findZone(svg, e.clientX, e.clientY)
    if (!hit) return
    setSaving(true)
    const point = {
      patient_id: patientId,
      consultation_id: consultationId || null,
      praticien_id: praticien.id,
      vue,
      type: typeActif,
      x: Math.round(hit.x * 100) / 100,
      y: Math.round(hit.y * 100) / 100,
    }
    const { data } = await supabase.from('schema_corporel_points').insert(point).select().single()
    if (data) setPoints(prev => [...prev, data])
    setSaving(false)
  }

  async function removeLastPoint() {
    const vuePoints = points.filter(p => p.vue === vue)
    if (!vuePoints.length) return
    const last = vuePoints[vuePoints.length - 1]
    await supabase.from('schema_corporel_points').delete().eq('id', last.id)
    setPoints(prev => prev.filter(p => p.id !== last.id))
  }

  async function clearVue() {
    if (!window.confirm('Effacer tous les points de cette vue ?')) return
    const ids = points.filter(p => p.vue === vue).map(p => p.id)
    if (!ids.length) return
    await supabase.from('schema_corporel_points').delete().in('id', ids)
    setPoints(prev => prev.filter(p => p.vue !== vue))
  }

  const ptsFace = points.filter(p => p.vue === 'face')
  const ptsDos = points.filter(p => p.vue === 'dos')
  const ptsVue = vue === 'face' ? ptsFace : ptsDos

  const svgPoints = ptsVue.map((p, i) => (
    `<circle key="${i}" cx="${p.x}" cy="${p.y}" r="6" fill="${TYPES[p.type]?.color}" stroke="white" stroke-width="1.5" />`
  )).join('')

  return (
    <div>
      <div style={{display:'flex', alignItems:'center', gap:6, flexWrap:'wrap', marginBottom:8}}>
        <div style={{display:'flex', gap:3, background:'var(--bg)', borderRadius:7, padding:2}}>
          {['face','dos'].map(v => (
            <button key={v} onClick={() => setVue(v)}
              style={{padding:'3px 10px', borderRadius:5, fontSize:11, fontWeight:600, cursor:'pointer',
                background: vue === v ? 'var(--surface)' : 'transparent',
                color: vue === v ? 'var(--text)' : 'var(--text-3)',
                border: vue === v ? '0.5px solid var(--border-md)' : 'none'}}>
              {v === 'face' ? 'Face' : 'Dos'}
            </button>
          ))}
        </div>
        {!readOnly && Object.entries(TYPES).map(([key, val]) => (
          <button key={key} onClick={() => setTypeActif(key)}
            style={{padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight: typeActif === key ? 700 : 400, cursor:'pointer',
              background: typeActif === key ? val.color : val.bg,
              color: typeActif === key ? '#fff' : val.text,
              border: `1px solid ${val.border}`}}>
            ● {val.label}
          </button>
        ))}
        {!readOnly && <>
          <button onClick={removeLastPoint} style={{fontSize:11, padding:'3px 8px', borderRadius:5, border:'0.5px solid var(--border-md)', background:'transparent', cursor:'pointer', color:'var(--text-2)'}}>↩</button>
          <button onClick={clearVue} style={{fontSize:11, padding:'3px 8px', borderRadius:5, border:'0.5px solid var(--border-md)', background:'transparent', cursor:'pointer', color:'var(--text-3)'}}>🗑</button>
        </>}
        {saving && <span style={{fontSize:10, color:'var(--text-3)'}}>…</span>}
      </div>

      <div style={{display:'flex', gap:10, marginBottom:6, fontSize:11}}>
        {Object.entries(TYPES).map(([key, val]) => {
          const cnt = ptsVue.filter(p => p.type === key).length
          return cnt > 0 ? <span key={key} style={{color: val.color, fontWeight:500}}>● {val.label} : {cnt}</span> : null
        })}
        {zoneHover && <span style={{color:'var(--text-3)', fontStyle:'italic', marginLeft:'auto'}}>{zoneHover}</span>}
      </div>

      <div style={{maxWidth:200, margin:'0 auto'}}>
        <svg viewBox="0 0 280 540" style={{width:'100%', cursor: readOnly ? 'default' : 'crosshair'}}
          onClick={addPoint}
          onMouseMove={e => {
            const hit = findZone(e.currentTarget, e.clientX, e.clientY)
            setZoneHover(hit ? hit.zone : '')
          }}
          onMouseLeave={() => setZoneHover('')}>
          <defs><style>{SVG_STYLE}</style></defs>
          <g id="g-face" style={{display: vue === 'face' ? '' : 'none'}}
            dangerouslySetInnerHTML={{__html: ZONES_FACE}} />
          <g id="g-dos" style={{display: vue === 'dos' ? '' : 'none'}}
            dangerouslySetInnerHTML={{__html: ZONES_DOS}} />
          <g dangerouslySetInnerHTML={{__html: svgPoints}} />
        </svg>
      </div>

      {!readOnly && (
        <div style={{fontSize:10, color:'var(--text-3)', textAlign:'center', marginTop:4}}>
          Cliquez sur le squelette · Type actif : <strong>{TYPES[typeActif]?.label}</strong>
        </div>
      )}
    </div>
  )
}
